export default __webpack_public_path__ + "static/media/view-back.c85b0b46.png";